import React from 'react'
import styled from 'styled-components'
import dashboardScreenshot from '../../img/dashboard-screenshot.webp'
import stretchesScreenshot from '../../img/stretches-screenshot.webp'
import notificationImg from '../../img/notification.webp'

const ShowcaseContainer = styled.div`
    perspective: 1000px;
    position: relative;
    width: 100%;
    aspect-ratio: 5 / 4;
    margin-bottom: 20px;

    @media (min-width: 950px) {
        width: 120%;
        margin-left: -10%;
    }
`

const Screenshot = styled.img`
    position: absolute;
`

const DashboardImage = styled(Screenshot)`
    width: 70%;
    top: -5%;
    left: 10%;
    transform: rotateY(10deg);
`

const StretchesImage = styled(Screenshot)`
    width: 70%;
    bottom: -5%;
    left: 25%;
    z-index: 1;
    transform: rotateY(-6deg);
`

const NotificationImage = styled.img`
    position: absolute;
    width: 65%;
    top: 18%;
    right: -2%;
    z-index: 2;
`

export default () => (
    <ShowcaseContainer>
        <DashboardImage src={dashboardScreenshot} alt="Keybreak dashboard" />
        <StretchesImage src={stretchesScreenshot} alt="Keybreak stretches" />
        <NotificationImage src={notificationImg} alt="Keybreak notification" />
    </ShowcaseContainer>
)
